import "core-js/modules/es6.regexp.replace";
import empty from "./carefullyEmpty.vue";
import inPreviewEmpty from "./empty.vue";
import normalItem from "./normalItem.vue";
import editProductItem from "./editProductItem.vue";
import { goToHome } from '@ykz/ykz-util/platform';
export default {
  name: 'carefully',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isEmpty: {
      default: false
    },
    end: {
      default: false
    },
    targetId: {
      default: ''
    },
    showTitle: {
      default: true
    },
    inPreview: {
      default: true
    },
    onlyShowSelected: {
      default: 0
    }
  },
  components: {
    empty: empty,
    inPreviewEmpty: inPreviewEmpty,
    normalItem: normalItem,
    editProductItem: editProductItem
  },
  data: function data() {
    return {
      dialog: {
        show: false,
        showContent: false
      },
      removeItem: null //要删除的
    };
  },

  mounted: function mounted() {
    var targetTop = 0;
    this.$nextTick(function () {
      if (this.targetId && String(this.targetId).indexOf('carefully_') >= 0 && $('#' + this.targetId).offset()) {
        targetTop = $('#' + this.targetId).offset().top;
      }
      this.$emit('totargetgoods', {
        from: 'carefully_',
        top: targetTop - $(window).height() * 0.2
      });
    });
  },
  methods: {
    toProductAddress: function toProductAddress(item) {
      this.$emit('todetail', $.extend(item, {
        saveItemId: 'carefully_' + item.goodsId
      }));
    },
    theSameCity: function theSameCity(oneCity, twoCity) {
      return oneCity.replace(/(市*$)/g, '') == twoCity.replace(/(市*$)/g, '');
    },
    // 删除
    remove: function remove() {
      this.$emit('remove', this.removeItem);
      this.closeDialog();
    },
    // 设置置顶
    toTop: function toTop(option) {
      this.$emit('totop', option);
    },
    addGoods: function addGoods() {
      // window.location.href =
      //   '/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=1'
      var url = '/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=1';
      goToHome(url);
    },
    // 展示确定删除弹窗
    showDialog: function showDialog(option) {
      var that = this;
      this.dialog.show = true;
      this.dialog.hasShow = true;
      this.removeItem = option;
      setTimeout(function () {
        that.dialog.showContent = true;
      }, 100);
    },
    //关闭删除弹窗
    closeDialog: function closeDialog() {
      var that = this;
      this.removeItem = null;
      that.dialog.showContent = false;
      setTimeout(function () {
        that.dialog.show = false;
      }, 200);
    }
  }
};